export default __webpack_public_path__ + "static/media/arrow-button.c53e93fd.svg";